import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import tournamentsReducer from './slices/tournaments';
import tournamentParticipantMusicReducer from './slices/tournament-participant-music';
import tournamentBookingPaymentsReducer from './slices/tournament-booking-payments';
import tournamentParticipantPaymentsReducer from './slices/tournament-participant-payments';
import tournamentParticipantDocumentReducer from './slices/tournament-participant-document';
import tournamentParticipantsReducer from './slices/tournament-participants';
import tournamentParticipantVotesReducer from './slices/tournament-participant-votes';
import tournamentBookingsReducer from './slices/tournament-bookings';
import tournamentCoachesReducer from './slices/tournament-coaches';
import tournamentJudgesReducer from './slices/tournament-judges';
import tournamentJudgeProfilesReducer from './slices/tournament-judge-profiles';
import tournamentJudgeParticipantsReducer from './slices/tournament-judge-participants';
import tournamentJudgeMessagesReducer from './slices/tournament-judge-messages';
import tournamentMediaReducer from './slices/tournament-media';
import tournamentAwardTemplatesReducer from './slices/tournament-award-templates';
import tournamentScheduleReducer from './slices/tournament-schedule';
import tournamentScheduleItemsReducer from './slices/tournament-schedule-items';
import participantsReducer from './slices/participants';
import judgesReducer from './slices/judges';
import judgeProfilesReducer from './slices/judge-profiles';
import usersReducer from './slices/users';
import telegramMessagesReducer from './slices/telegram-messages';
import ticketsReducer from './slices/tickets';
import coachesReducer from './slices/coaches';
import ticketPricesReducer from './slices/ticket-prices';
import participantPricesReducer from './slices/participant-prices';
import bookingPricesReducer from './slices/booking-prices';
import coachDiscountsReducer from './slices/coach-discounts';
import coachBookingDiscountsReducer from './slices/coach-booking-discounts';
import coachTicketDiscountsReducer from './slices/coach-ticket-discounts';
import categoriesReducer from './slices/categories';
import citiesReducer from './slices/cities';
import managersReducer from './slices/managers';
import superiorJudgesReducer from './slices/superior-judges';

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
    tournaments: tournamentsReducer.getReducer(),
    tournamentBookingPayments: tournamentBookingPaymentsReducer.getReducer(),
    tournamentParticipantMusic: tournamentParticipantMusicReducer.getReducer(),
    tournamentParticipantPayments: tournamentParticipantPaymentsReducer.getReducer(),
    tournamentParticipantDocument: tournamentParticipantDocumentReducer.getReducer(),
    tournamentParticipants: tournamentParticipantsReducer.getReducer(),
    tournamentParticipantVotes: tournamentParticipantVotesReducer.getReducer(),
    tournamentBookings: tournamentBookingsReducer.getReducer(),
    tournamentAwardTemplates: tournamentAwardTemplatesReducer.getReducer(),
    tournamentMedia: tournamentMediaReducer.getReducer(),
    tournamentJudges: tournamentJudgesReducer.getReducer(),
    tournamentJudgeProfiles: tournamentJudgeProfilesReducer.getReducer(),
    tournamentJudgeParticipants: tournamentJudgeParticipantsReducer.getReducer(),
    tournamentJudgeMessages: tournamentJudgeMessagesReducer.getReducer(),
    tournamentCoaches: tournamentCoachesReducer.getReducer(),
    tournamentSchedule: tournamentScheduleReducer.getReducer(),
    tournamentScheduleItems: tournamentScheduleItemsReducer.getReducer(),
    participants: participantsReducer.getReducer(),
    categories: categoriesReducer.getReducer(),
    cities: citiesReducer.getReducer(),
    coaches: coachesReducer.getReducer(),
    judges: judgesReducer.getReducer(),
    judgeProfiles: judgeProfilesReducer.getReducer(),
    coachDiscounts: coachDiscountsReducer.getReducer(),
    coachBookingDiscounts: coachBookingDiscountsReducer.getReducer(),
    coachTicketDiscounts: coachTicketDiscountsReducer.getReducer(),
    users: usersReducer.getReducer(),
    managers: managersReducer.getReducer(),
    superiorJudges: superiorJudgesReducer.getReducer(),
    telegramMessages: telegramMessagesReducer.getReducer(),
    tickets: ticketsReducer.getReducer(),
    participantPrices: participantPricesReducer.getReducer(),
    ticketPrices: ticketPricesReducer.getReducer(),
    bookingPrices: bookingPricesReducer.getReducer(),
});

export default rootReducer;
